// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__HZ6Fg","Button":"header_Button__3u8GU","image":"header_image__2v7Kk"};